import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import App from './App.vue';
import router from './router';
import store from './store';
import 'normalize.css';
import 'frow';
import 'bulma';

axios.interceptors.response.use(
  response => response,
  (error) => {
    if (error.response.status === 401) {
      store.commit('logout');
    }
    return Promise.reject(error);
  },
);

let protocol = 'http://';
if (location.protocol === 'https:') {
  protocol = 'https://';
}
Vue.prototype.$API = `${location.protocol}//${process.env.VUE_APP_API}`;

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
